const HammerAndWrench = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='14'
    height='12'
    viewBox='0 0 14 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.53255 6.64922L8.25977 7.922L11.7599 11.4221L13.0327 10.1494L9.53255 6.64922Z'
      fill='currentColor'
    />
    <path
      d='M10.8074 5.08199C12.0494 5.08199 13.0574 4.07399 13.0574 2.83199C13.0574 2.37299 12.9224 1.94999 12.6794 1.58999L10.8074 3.46199L10.1684 2.82299L12.0404 0.950986C11.6804 0.716986 11.2574 0.572986 10.7984 0.572986C9.55636 0.572986 8.54836 1.58099 8.54836 2.82299C8.54836 3.11099 8.61136 3.38999 8.71036 3.64199L7.62136 4.73999L6.67636 3.78599L7.31536 3.14699L6.03736 1.87799L7.30636 0.599986C6.60436 -0.102014 5.46136 -0.102014 4.75936 0.599986L2.22136 3.14699L3.17536 4.10099H1.25836L0.943359 4.41599L3.49036 6.96299L3.80536 6.64799L3.81436 4.73999L4.76836 5.69399L5.40736 5.05499L6.36136 6.00899L2.22136 10.149L3.49036 11.418L9.98836 4.91999C10.2404 5.01899 10.5194 5.08199 10.8074 5.08199Z'
      fill='currentColor'
    />
  </svg>
);

export default HammerAndWrench;
